import React from "react";

const Footer = () => (
  <ul className="footer">
      <li className="footer-special">&#169; {(new Date()).getFullYear()} Copyright Notice</li>
  </ul>
);

export default Footer;
